<script setup lang="ts">
  import 'quill/dist/quill.core.css';
  import { computed } from 'vue';

  defineOptions({
    inheritAttrs: false,
  });

  const props = defineProps({
    content: { type: String },
  });

  const formattedContent = computed(() => {
    if (!props.content) return '';
    return props.content
      .replace(/<h1([^>]*)>/gi, '<h2$1>')
      .replace(/<\/h1>/gi, '</h2>');
  });
</script>
<template>
  <div class="ql-editor" v-html="formattedContent" />
</template>
<style lang="scss">
  :root {
    --sf-quill-content-font-size: var(--font-size, 1rem);
    --sf-quill-content-line-height: var(--line-height, 1.7);
  }

  .ql-editor {
    --font-size: var(--sf-quill-content-font-size);
    --line-height: var(--sf-quill-content-line-height);
    font-size: var(--sf-quill-content-font-size);
    line-height: var(--sf-quill-content-line-height);
    padding: 0;

    a {
      text-decoration: underline;
    }

    @media(hover: hover) {
      a:hover {
        color: var(--color-anchor-hover);
      }
    }

    .ql-video {
      width: 100%;
      aspect-ratio: 16/9;
    }

    ul:not(:has(li[data-list="bullet"])) {
      padding-left: 2rem;

      li {
        list-style-type: disc;
        padding: 0;
      }
    }

    ol:not(:has(li[data-list="ordered"])) {
      padding-left: 2rem;

      li {
        list-style-type: decimal;
        padding: 0;
      }
    }
  }
</style>
